import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const AddFriendsContainer = styled.div`
  .package-card {
    position: relative;
    cursor: pointer;
    .card-badge {
      position: absolute;
      right: -14px;
      top: -11px;
    }
    .card-top {
      padding: 17px 31px;
      button {
        &.btn1 {
        }
      }
    }
    .options-wrapper {
      border-top: solid 1px rgba(192, 198, 217, 0.5);
      margin-top: 15px;
      padding: 17px 31px;
      h4 {
        display: flex;
        align-items: center;
        span {
          border-bottom: dotted 2px ${colors.blueDark};
        }
        .option-icon {
          min-width: 24px;
        }
      }
    }
    &:hover {
      box-shadow: 0px 8px 42px rgba(36, 42, 53, 0.18);
      border-radius: 8px;
    }
  }
  @media (max-width: ${breakpoints.xl}px) {
  }
  .modal-custom-body {
    background-color: white;
    border-radius: 15px;

    h4 {
      text-align: center !important;
    }

    .answer-images h4 {
      text-align: left !important;
    }
  }

  .modal-custom-footer {
    .actions {
      padding: 8px 0 !important;
      display: flex;
      justify-content: space-between;
      .btn {
        margin-left: 1rem;
      }

      .green {
        background-color: #4e9e69 !important;
        border-color: #4e9e69 !important;
        color: white !important;
      }

      .gray {
        background-color: #4c4c4c !important;
        border-color: #4c4c4c !important;
        color: white !important;
      }

      .blue {
        background-color: #0d89cf !important;
        border-color: #0d89cf !important;
        color: white !important;
      }
    }
  }
`
